import type { DataTypeLocator } from '@helo/cms'

import { colorOverrideOptions } from '../../Colors'
import { Descriptor } from '../../Descriptor'
import { formatOptions } from '../../Format'
import { Options } from '../../Options'
import { chartLineOptions } from '../ChartLine/ChartLine.options'
import { chartMarkOptions } from '../ChartMark'

export const chartVisualizations = ['line', 'bar', 'pie'] as const
export type ChartVisualization = (typeof chartVisualizations)[number]

const dataTypeLocatorOfType = Options.scalar<DataTypeLocator>('DataTypeLocator')

export const chartSeriesOptions = {
  ...Options.asRecord(
    Options.createOption({
      key: 'visualization',
      inputKind: 'select',
      selectChoices: [
        { value: 'line', label: 'Line' },
        { value: 'bar', label: 'Bar' },
        { value: 'pie', label: 'Pie' },
      ],
      required: true,
      label: 'Visualization',
      description: 'Default visualization for series that omit their own.',
      category: 'Data',
    }),
    Options.createOption({
      key: 'measureLocator',
      inputKind: 'data_type_locator',
      ofType: dataTypeLocatorOfType,
      label: 'Measure',
      description: 'Field locator for a series measure.',
      category: 'Data',
    }),
    Descriptor.options.label,
    Options.createOption({
      key: 'seriesByLocator',
      inputKind: 'data_type_locator',
      ofType: dataTypeLocatorOfType,
      label: 'Series by',
      description:
        'Dimension that pivots long-format rows into multiple series. Omit when series come from additional measures.',
      category: 'Data',
    }),
    Options.createNested({
      key: '_series',
      list: true,
      required: true,
      label: 'Series',
      description: 'Measure series to plot.',
      category: 'Data',
    }),
  ),
  ...formatOptions,
  ...colorOverrideOptions,
  ...chartMarkOptions,
  ...chartLineOptions,
}

export type ChartSeriesOptions = Options.TypeOf<typeof chartSeriesOptions>
/** One `_series` item — the root `_series` list is not itself a series field. */
export type ChartSeriesItem = Omit<ChartSeriesOptions, '_series'>
